import { ReactElement } from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import InputAdornment from '@mui/material/InputAdornment';
import Typography from '../Typography';
import CountryFlag from '../CountryFlag';

// Map currencies to their corresponding country codes
const currencyToCountryCode: Record<string, string> = {
  USD: 'US',
  MXN: 'MX',
  DKK: 'DK',
  EUR: 'EU',
  PEN: 'PE',
  CNY: 'CN',
  HKD: 'HK',
  CAD: 'CA',
  AED: 'AE',
  COP: 'CO',
  CLP: 'CL',
  GTQ: 'GT',
  UYU: 'UY',
};

// Keep this for backward compatibility, but use the new CountryFlag component
export const currencyIconMap: Record<string, ReactElement> = Object.entries(currencyToCountryCode).reduce(
  (acc, [currency, countryCode]) => ({
    ...acc,
    [currency]: <CountryFlag countryCode={countryCode} size={24} />,
  }),
  {}
);

export default function CurrencyAdornment({ currency }: { currency: string }) {
  return (
    <InputAdornment position="start" sx={{}}>
      <Box
        sx={{ display: 'flex', gap: '8px', alignItems: 'center', justifyContent: 'center', width: '64px' }}
      >
        {currencyIconMap[currency]}
        <Typography>{currency}</Typography>
      </Box>
      <Divider
        orientation="vertical"
        sx={{
          height: '42px',
          marginLeft: '1.5em',
        }}
      />
    </InputAdornment>
  );
}
